<template>
  <li>
    <a href="#" data-toggle="collapse" :data-target="`#submenu-${label}`">
      <span :class="[iconClass, 'sidebar-icon']"></span>
      <span>{{ label }}</span>
      <span :class="[caretClass, 'pull-right']"></span>
    </a>
    <ul :id="`submenu-${label}`" class="collapse nav nav-children">
      <template
        v-for="{
          label: childLabel,
          linkName: childName,
          iconClass: childIconClass,
          adminOnly,
        } in children"
      >
        <router-link
          v-if="isAdmin || !adminOnly"
          :key="childName"
          :tag="'li'"
          class="nav-child"
          :to="{ name: childName ? childName : null }"
        >
          <a href="#">
            <span v-if="childIconClass" :class="[childIconClass, 'sidebar-icon']"></span>
            <span class="pl-30">{{ childLabel }}</span>
          </a>
        </router-link>
      </template>
    </ul>
  </li>
</template>

<script>
  export default {
    props: {
      iconClass: {
        type: String,
      },
      label: {
        type: String,
      },
      children: {
        type: Array,
        required: true,
      },
      isAdmin: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isOpen: false,
      };
    },
    mounted() {
      $(`#submenu-${this.label}`).on('hide.bs.collapse', () => {
        this.isOpen = false;
      });
      $(`#submenu-${this.label}`).on('show.bs.collapse', () => {
        this.isOpen = true;
      });
    },

    computed: {
      caretClass: (vm) => (vm.isOpen ? 'fas fa-chevron-down' : 'fas fa-chevron-left'),
    },
  };
</script>

<style lang="scss" scoped>
  .nav-children {
    border-bottom: 1px solid #004054;
  }

  .nav-children > li > a {
    font-size: 14px;
    color: white;
    padding: 20px;
    background-color: #777 !important;

    * {
      vertical-align: middle;
    }

    &:hover,
    &:focus {
      color: #fff;
      background-color: #3b576a !important;
    }
  }

  .nav-children > .active a,
  .nav-children > .active a:focus,
  .nav-children > .active a:hover {
    font-weight: bold;
    color: #fff;
    background-color: #0073ad !important;
  }
</style>
